import { IBadgeProps } from '.';
import { css, styled } from 'styled-components';

import { typography } from '@/styles/helpers';

interface IScBadgeProps extends IBadgeProps {}

export const ScBadge = styled.div<IScBadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border-radius: 3px;

  ${({ type }) =>
    type === 'new'
      ? css`
          width: 32px;
          gap: 10px;
          align-self: stretch;
          background: #0ec277;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
          color: ${({ theme }) => theme.whiteColor};
          font-size: 10px;
          font-style: italic;
          font-weight: 600;
          line-height: 16px;
          letter-spacing: 0px;
          text-transform: uppercase;
        `
      : css`
          width: 24px;
          height: 24px;
          background: rgba(25, 25, 25, 0.8);
          backdrop-filter: blur(5px);
        `}
`;
